import React, { useState } from 'react';
import api from '../api';

function ChangePassword({ onClose }) {
  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [message, setMessage] = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew]         = useState(false);

  const handleSubmit = async () => {
    setError(''); setMessage('');

    if (!form.current_password) {
      setError('தற்போதைய கடவுச்சொல் போடுங்கள்!'); return;
    }
    if (form.new_password.length < 6) {
      setError('புது கடவுச்சொல் குறைந்தது 6 எழுத்து!'); return;
    }
    if (form.new_password !== form.confirm_password) {
      setError('புது கடவுச்சொல் match ஆகவில்லை!'); return;
    }
    if (form.current_password === form.new_password) {
      setError('புது கடவுச்சொல் வேறாக இருக்கணும்!'); return;
    }

    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      setMessage('✅ கடவுச்சொல் மாற்றப்பட்டது!');
      setForm({ current_password:'', new_password:'', confirm_password:'' });
      setTimeout(() => { if (onClose) onClose(); }, 2000);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (detail === 'Current password incorrect') {
        setError('❌ தற்போதைய கடவுச்சொல் தவறு!');
      } else {
        setError('❌ ' + (detail || 'Error occurred!'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.overlay} onClick={e => e.target === e.currentTarget && onClose && onClose()}>
      <div style={s.modal}>
        {/* Header */}
        <div style={s.header}>
          <h2 style={s.title}>🔑 கடவுச்சொல் மாற்று</h2>
          {onClose && (
            <button style={s.closeBtn} onClick={onClose}>✕</button>
          )}
        </div>

        {/* Messages */}
        {message && <div style={s.success}>{message}</div>}
        {error && (
          <div style={s.err}>
            {error}
            <span style={{cursor:'pointer'}} onClick={() => setError('')}>✕</span>
          </div>
        )}

        {/* Form */}
        <div style={s.body}>
          {/* Current password */}
          <div style={s.field}>
            <label style={s.label}>தற்போதைய கடவுச்சொல் *</label>
            <div style={s.inputWrap}>
              <input
                style={s.input}
                type={showCurrent ? 'text' : 'password'}
                placeholder="தற்போதைய கடவுச்சொல்"
                value={form.current_password}
                onChange={e => setForm({...form, current_password: e.target.value})}
              />
              <button style={s.eyeBtn}
                onClick={() => setShowCurrent(!showCurrent)}>
                {showCurrent ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* New password */}
          <div style={s.field}>
            <label style={s.label}>புது கடவுச்சொல் *</label>
            <div style={s.inputWrap}>
              <input
                style={s.input}
                type={showNew ? 'text' : 'password'}
                placeholder="புது கடவுச்சொல் (குறைந்தது 6 எழுத்து)"
                value={form.new_password}
                onChange={e => setForm({...form, new_password: e.target.value})}
              />
              <button style={s.eyeBtn}
                onClick={() => setShowNew(!showNew)}>
                {showNew ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* Confirm password */}
          <div style={s.field}>
            <label style={s.label}>புது கடவுச்சொல் உறுதிப்படுத்து *</label>
            <input
              style={{
                ...s.input,
                borderColor: form.confirm_password && form.new_password !== form.confirm_password
                  ? '#e74c3c' : '#ddd'
              }}
              type="password"
              placeholder="மீண்டும் புது கடவுச்சொல்"
              value={form.confirm_password}
              onChange={e => setForm({...form, confirm_password: e.target.value})}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            />
            {form.confirm_password && form.new_password !== form.confirm_password && (
              <div style={{color:'#e74c3c', fontSize:'12px', marginTop:'4px'}}>
                ❌ கடவுச்சொல் match ஆகவில்லை!
              </div>
            )}
            {form.confirm_password && form.new_password === form.confirm_password && (
              <div style={{color:'#27ae60', fontSize:'12px', marginTop:'4px'}}>
                ✅ Match ஆகிறது!
              </div>
            )}
          </div>

          {/* Buttons */}
          <div style={s.btnRow}>
            <button
              style={{...s.submitBtn, opacity: loading ? 0.7 : 1}}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? '⏳ மாற்றுகிறது...' : '🔑 கடவுச்சொல் மாற்று'}
            </button>
            {onClose && (
              <button style={s.cancelBtn} onClick={onClose}>
                ரத்து
              </button>
            )}
          </div>
        </div>

        {/* Tips */}
        <div style={s.tips}>
          <div style={s.tipTitle}>💡 குறிப்பு:</div>
          <div style={s.tip}>• குறைந்தது 6 எழுத்து இருக்கணும்</div>
          <div style={s.tip}>• எண்கள் + எழுத்துக்கள் சேர்த்தால் பாதுகாப்பு அதிகம்</div>
          <div style={s.tip}>• யாரிடமும் share பண்ணாதீர்கள்!</div>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'},
  modal:{background:'white',borderRadius:'16px',width:'100%',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)',overflow:'hidden'},
  header:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'20px 24px',background:'#2c3e50',color:'white'},
  title:{margin:0,fontSize:'18px',fontWeight:'700',color:'white'},
  closeBtn:{background:'rgba(255,255,255,0.2)',border:'none',color:'white',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:{padding:'24px'},
  field:{marginBottom:'16px'},
  label:{display:'block',fontSize:'13px',fontWeight:'600',color:'#555',marginBottom:'6px'},
  inputWrap:{position:'relative',display:'flex',alignItems:'center'},
  input:{width:'100%',padding:'11px 14px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'14px',boxSizing:'border-box',outline:'none'},
  eyeBtn:{position:'absolute',right:'10px',background:'none',border:'none',cursor:'pointer',fontSize:'16px',padding:'4px'},
  btnRow:{display:'flex',gap:'10px',marginTop:'20px'},
  submitBtn:{flex:1,background:'#2c3e50',color:'white',border:'none',padding:'12px',borderRadius:'8px',cursor:'pointer',fontSize:'15px',fontWeight:'700'},
  cancelBtn:{background:'#ddd',color:'#555',border:'none',padding:'12px 20px',borderRadius:'8px',cursor:'pointer',fontWeight:'600'},
  success:{background:'#e8f8f0',border:'1px solid #27ae60',color:'#27ae60',padding:'12px 16px',margin:'0 24px 16px',borderRadius:'8px',fontWeight:'600'},
  err:{background:'#fff0f0',border:'1px solid #e74c3c',color:'#e74c3c',padding:'12px 16px',margin:'0 24px 16px',borderRadius:'8px',display:'flex',justifyContent:'space-between'},
  tips:{background:'#f8f9fa',padding:'16px 24px',borderTop:'1px solid #eee'},
  tipTitle:{fontSize:'13px',fontWeight:'700',color:'#555',marginBottom:'6px'},
  tip:{fontSize:'12px',color:'#888',marginBottom:'3px'},
};

export default ChangePassword;
